module.exports = __webpack_public_path__ + "img/marker_one_blue3.67a94f6c.png";